{
  "AUTOMATION": {
    "HEADER": "Automation",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Add Automation Rule",
    "LOADING": "Fetching automation rules",
    "ADD": {
      "TITLE": "Add Automation Rule",
      "SUBMIT": "Create",
      "CANCEL_BUTTON_TEXT": "Cancel",
      "FORM": {
        "NAME": {
          "LABEL": "Rule Name",
          "PLACEHOLDER": "Enter rule name",
          "ERROR": "Name is required"
        },
        "DESC": {
          "LABEL": "Description",
          "PLACEHOLDER": "Enter rule description",
          "ERROR": "Description is required"
        },
        "EVENT": {
          "LABEL": "Event",
          "PLACEHOLDER": "Please select one",
          "ERROR": "Event is required"
        },
        "PHASE": {
          "LABEL": "Phase"
        },
        "ORDER": {
          "LABEL": "Order",
          "ERROR": "Order is required"
        },
        "CONDITIONS": {
          "LABEL": "Conditions"
        },
        "ACTIONS": {
          "LABEL": "Actions"
        }
      },
      "CONDITION_BUTTON_LABEL": "Add Condition",
      "ACTION_BUTTON_LABEL": "Add Action",
      "API": {
        "SUCCESS_MESSAGE": "Automation rule added successfully",
        "ERROR_MESSAGE": "Could not able to create a automation rule, Please try again later"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Phase",
        "ORDER": "Order",
        "NAME": "Name",
        "DESCRIPTION": "Description",
        "ACTIVE": "Active",
        "CREATED_ON": "Created on",
        "WAIT": "Wait"
      },
      "404": "No automation rules found",
      "TABS": {
        "ALL": "All",
        "INSTANT": "Instant",
        "DELAYED": "Delayed"
      },
      "WAITS": "Waits {duration}"
    },
    "DELETE": {
      "TITLE": "Delete Automation Rule",
      "SUBMIT": "Delete",
      "CANCEL_BUTTON_TEXT": "Cancel",
      "CONFIRM": {
        "TITLE": "Confirm Deletion",
        "MESSAGE": "Are you sure to delete ",
        "YES": "Yes, Delete ",
        "NO": "No, Keep "
      },
      "API": {
        "SUCCESS_MESSAGE": "Automation rule deleted successfully",
        "ERROR_MESSAGE": "Could not able to delete a automation rule, Please try again later"
      }
    },
    "EDIT": {
      "TITLE": "Edit Automation Rule",
      "SUBMIT": "Update",
      "CANCEL_BUTTON_TEXT": "Cancel",
      "API": {
        "SUCCESS_MESSAGE": "Automation rule updated successfully",
        "ERROR_MESSAGE": "Could not update automation rule, Please try again later"
      }
    },
    "CLONE": {
      "TOOLTIP": "Clone",
      "API": {
        "SUCCESS_MESSAGE": "Automation cloned successfully",
        "ERROR_MESSAGE": "Could not clone automation rule, Please try again later"
      }
    },
    "FORM": {
      "EDIT": "Edit",
      "CREATE": "Create",
      "DELETE": "Delete",
      "CANCEL": "Cancel",
      "RESET_MESSAGE": "Changing event type will reset the conditions and events you have added below"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "You need to have atleast one condition to save",
      "CONTACT_CUSTOM_ATTR_LABEL": "Contact Custom Attributes",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Conversation Custom Attributes"
    },
    "ACTION": {
      "DELETE_MESSAGE": "You need to have atleast one action to save",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Enter your message here",
      "TEAM_DROPDOWN_PLACEHOLDER": "Select teams",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Select the email inbox and address to send from",
      "SUBJECT_INPUT_PLACEHOLDER": "Email subject",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Select the SMS inbox to send from",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Enter the SMS text",
      "SMS_COUNTER": "{length}/{limit} characters, {segments} SMS (before the variables are filled in)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Activate Automation Rule",
      "DEACTIVATION_TITLE": "Deactivate Automation Rule",
      "ACTIVATION_DESCRIPTION": "This action will activate the automation rule '{automationName}'. Are you sure you want to proceed?",
      "DEACTIVATION_DESCRIPTION": "This action will deactivate the automation rule '{automationName}'. Are you sure you want to proceed?",
      "ACTIVATION_SUCCESFUL": "Automation Rule Activated Successfully",
      "DEACTIVATION_SUCCESFUL": "Automation Rule Deactivated Successfully",
      "ACTIVATION_ERROR": "Could not Activate Automation, Please try again later",
      "DEACTIVATION_ERROR": "Could not Deactivate Automation, Please try again later",
      "CONFIRMATION_LABEL": "Yes",
      "CANCEL_LABEL": "No"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Could not upload attachment, Please try again",
      "LABEL_IDLE": "Upload Attachment",
      "LABEL_UPLOADING": "Uploading...",
      "LABEL_UPLOADED": "Successfully Uploaded",
      "LABEL_UPLOAD_FAILED": "Upload Failed"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Value is required",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Value must be between 0 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required",
      "ORDER_REQUIRED": "Order is required",
      "ORDER_MUST_BE_AT_LEAST_ONE": "Order must be at least 1"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "This action only works when the rule phase is set to 'Before labeling'.",
      "SKIP_AUTO_LABELING": "This action only works when the rule phase is set to 'Before labeling'.",
      "MOVE_CONVERSATION_TO_INBOX": "Only email and web chat conversations can be moved to an email inbox, and a web chat only when the contact has an email address. Otherwise the conversation stays where it is and a private note is added instead.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Starts a new conversation with the contact in the selected email inbox, emails them the message and resolves the conversation. This happens every time the rule runs. If the contact has no email address, nothing is sent and a private note is added instead.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Starts a new conversation with the contact in the selected SMS inbox, texts them the message and resolves the conversation. This happens every time the rule runs. The message is plain text without attachments. If the contact has no phone number, nothing is sent and a private note is added instead."
    },
    "NOTICES": {
      "AI_PROMPT": "Each individual evaluation is charged.",
      "INCOMING_MESSAGES_COUNT": "This refers to the number of incoming messages in the conversation.",
      "OUTGOING_MESSAGES_COUNT": "This refers to the number of outgoing messages in the conversation."
    },
    "PHASE": {
      "BEFORE_LABELING": "Before labeling",
      "AFTER_LABELING": "After labeling"
    },
    "NONE_OPTION": "None",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Incoming Message",
      "OUTGOING": "Outgoing Message",
      "PRIVATE": "Private Note",
      "AI_SUMMARY": "AI Summary"
    },
    "YES_NO_VALUES": {
      "YES": "Yes",
      "NO": "No"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Instagram DM",
      "FACEBOOK_COMMENT": "Facebook Comment"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Conversation Created",
      "CONVERSATION_UPDATED": "Conversation Updated",
      "MESSAGE_CREATED": "Message Created",
      "CONVERSATION_OPENED": "Conversation Opened",
      "CONVERSATION_RESOLVED": "Conversation Resolved",
      "PHONE_CALL_FINISHED": "Phone Call Finished"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Assign to Agent",
      "ASSIGN_TEAM": "Assign a Team",
      "ADD_LABEL": "Add a Label",
      "REMOVE_LABEL": "Remove a Label",
      "SEND_EMAIL_TO_TEAM": "Send an Email to Team",
      "SEND_EMAIL_TRANSCRIPT": "Send an Email Transcript",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Send a Detailed Email Transcript",
      "MUTE_CONVERSATION": "Mute Conversation",
      "SNOOZE_CONVERSATION": "Snooze Conversation",
      "RESOLVE_CONVERSATION": "Resolve Conversation",
      "OPEN_CONVERSATION": "Open Conversation",
      "SEND_WEBHOOK_EVENT": "Send Webhook Event",
      "SEND_ATTACHMENT": "Send Attachment",
      "SEND_MESSAGE": "Send a Message",
      "ADD_NOTE": "Add a Note",
      "CHANGE_PRIORITY": "Change Priority",
      "ADD_SLA": "Add SLA",
      "SKIP_AUTO_PRIORITY": "Skip Auto Priority",
      "SKIP_AUTO_LABELING": "Skip Auto Labeling",
      "AUTO_TRANSLATE": "Translate Message",
      "AUTO_TRANSLATE_CONVERSATION": "Translate Conversation",
      "MOVE_CONVERSATION_TO_INBOX": "Move Conversation to Inbox",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Send Message in New Conversation",
      "SEND_SMS_IN_NEW_CONVERSATION": "Send SMS in New Conversation",
      "STOP_PROCESSING_RULES": "Stop Processing Rules"
    },
    "ATTRIBUTES": {
      "AI_FILTER": "AI Filter",
      "MESSAGE_TYPE": "Message Type",
      "MESSAGE_CONTAINS": "Message Content",
      "EMAIL": "Contact email",
      "INBOX": "Inbox",
      "CHANNEL_TYPE": "Inbox Type",
      "CONVERSATION_LANGUAGE": "Conversation Language",
      "PHONE_NUMBER": "Phone Number",
      "STATUS": "Status",
      "BROWSER_LANGUAGE": "Browser Language",
      "MAIL_SUBJECT": "Email Subject",
      "COUNTRY_NAME": "Country",
      "MARKETPLACE_COUNTRY": "Marketplace country",
      "REFERER_LINK": "Referrer Link",
      "ASSIGNEE_NAME": "Assignee",
      "TEAM_NAME": "Team",
      "PRIORITY": "Priority",
      "CALL_DIRECTION": "Call Direction",
      "MISSED_CALL": "Missed Call",
      "MISSED_CALL_COUNT": "Number of missed calls",
      "MESSAGE_SOURCE_TYPE": "Message Source Type",
      "INCOMING_MESSAGE_COUNT": "Number of incoming messages",
      "OUTGOING_MESSAGE_COUNT": "Number of outgoing messages",
      "LABEL": "Label",
      "EMAIL_RECIPIENTS": "Email Recipient",
      "EMAIL_AUTO_REPLY": "Email is an automated reply",
      "ATTACHMENT_EXTENSION": "Attachment Extension",
      "EXTENSION": "Called extension",
      "WORKING_HOURS": "Within working hours",
      "AGENT_REPLIED": "Agent replied since the status change"
    },
    "WAIT": {
      "RUN_LABEL": "Run the actions",
      "INSTANT": "On event",
      "DELAYED": "Delayed",
      "TRIGGER_LABEL": "Wait until",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "A conversation stays in a status",
        "CUSTOMER_UNRESPONSIVE": "The customer does not answer an agent",
        "AGENT_UNRESPONSIVE": "The customer gets no agent reply"
      },
      "STATUS_LABEL": "Status",
      "STATUSES": {
        "OPEN": "Open",
        "PENDING": "Pending",
        "SNOOZED": "Snoozed",
        "RESOLVED": "Resolved"
      },
      "DELAY_LABEL": "Wait for",
      "DELAY_ERROR": "Enter a wait between 1 minute and 30 days",
      "DURATION": {
        "MINUTES": "{count} min",
        "HOURS": "{count} h",
        "DAYS": "{count} d"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "The actions run when a conversation has been {status} for {duration}. A status change before then cancels them. Labels, working hours and agent replies are checked when the wait ends.",
        "CUSTOMER_UNRESPONSIVE": "The actions run when the customer has not answered for {duration} after an agent's message. A customer reply cancels them; a new agent message restarts the wait.",
        "AGENT_UNRESPONSIVE": "The actions run when the customer has waited {duration} without an agent reply. An agent reply cancels them."
      }
    }
  }
}
